// extracted by mini-css-extract-plugin
module.exports = {"editLink":"CreatorBanner_editLink__Ib8a1"};